import React from 'react';
import ShareButtons from '../ShareButtons';
import {
  ArticleText,
  ArticleSectionStyle,
  ArticleContainer,
} from './styles/ArticlesStyle';
import ArticleSection from './ArticleSection';

interface ListItem {
  subtitle?: string;
  text: string;
  link?: {
    url: string;
    text: string;
    target?: string;
    rel?: string;
  };
}

interface Section {
  title: string;
  content: string | (string | ListItem)[] | string[];
  type: 'text' | 'list' | 'text-image' | 'image' | 'sub-headers';
  imageUrl?: string;
  description?: string;
  isBold?: boolean;
  sectionLink?: {
    url: string;
    text: string;
  };
}

interface ArticleContentProps {
  introduction: string;
  sections: Section[];
  shareUrl: string;
  shareTitle: string;
}

const ArticleContent: React.FC<ArticleContentProps> = ({
  introduction,
  sections,
  shareUrl,
  shareTitle,
}) => {
  return (
    <ArticleContainer>
      {/* <ShareButtons url={shareUrl} title={shareTitle} /> */}

      <ArticleSectionStyle>
        <ArticleText dangerouslySetInnerHTML={{ __html: introduction }} />
      </ArticleSectionStyle>

      {sections.map((section, index) => (
        <ArticleSectionStyle key={index}>
          <ArticleSection
            title={section.title}
            content={section.content}
            type={section.type}
            imageUrl={section.imageUrl}
            description={section.description}
            isBold={section.isBold}
            sectionLink={section.sectionLink}
          />
        </ArticleSectionStyle>
      ))}
    </ArticleContainer>
  );
};

export default ArticleContent;
